import { looksLikeLabel } from "../model/lib.js";
import { familyKey } from "../model/text.js";

const KNOWN: Record<string, string> = {
  weights: "weights",
  "weights prep": "weights",
  musculation: "weights",
  sprints: "sprints",
  sprint: "sprints",
  running: "running",
  run: "running",
  hurdles: "hurdles",
  haies: "hurdles",
  gs: "gs",
  jumps: "jumps",
  hj: "jumps",
  lj: "jumps",
  pv: "jumps",
  throws: "throws",
};

const SPARE = ["a", "b", "c"];

/** A neutral tint per family; the family's first word is the text, so the tint is never the only cue. */
export function familyTone(label: string): string {
  if (!looksLikeLabel(label)) return "text";
  const key = familyKey(label);
  const known = KNOWN[key] ?? KNOWN[key.split(" ")[0] ?? ""];
  if (known) return known;
  let hash = 0;
  for (const ch of key) hash = (hash * 31 + ch.charCodeAt(0)) | 0;
  return SPARE[Math.abs(hash) % SPARE.length]!;
}

export function Chip({ label, undefinedLabel, selected }: { label: string; undefinedLabel?: boolean; selected?: boolean }) {
  return (
    <span
      className={"bp-chip bp-tone-" + familyTone(label) + (undefinedLabel ? " is-undefined" : "") + (selected ? " is-selected" : "")}
      title={undefinedLabel ? `${label} is not defined yet` : undefined}
    >
      <span className="bp-chip-text">{label}</span>
      {undefinedLabel ? (
        <span className="bp-chip-flag" aria-hidden="true">
          !
        </span>
      ) : null}
      {undefinedLabel ? <span className="sr">, not defined</span> : null}
    </span>
  );
}
